const features = [
  {
    icon: 'ri-stack-line',
    title: '海量漫画资源',
    desc: '收录超过20,000部日漫、韩漫、国漫作品，涵盖热血、恋爱、悬疑、奇幻等所有热门题材，持续更新中。',
  },
  {
    icon: 'ri-vip-diamond-line',
    title: '完全免费无限制',
    desc: '所有漫画内容永久免费阅读，无付费墙、无章节限制、无隐藏收费，真正实现全站免费畅读体验。',
  },
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '流畅下拉式阅读',
    desc: '专为移动端和桌面端优化的竖屏下拉阅读模式，翻页流畅无卡顿，沉浸式追更体验让你停不下来。',
  },
  {
    icon: 'ri-rocket-line',
    title: '每日同步更新',
    desc: '热门连载第一时间同步汉化更新，每日新增超过100个章节，追更党永远不会错过最新剧情。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            为什么数百万漫友选择哔咔动漫？四大核心优势让你放心追更
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f) => (
            <div
              key={f.title}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${f.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}